<template>
  <div class="d-flex flex-column flex-root error-page">
    <div
      class="d-flex flex-column flex-center flex-column-fluid p-10 p-sm-30">
      <div class="error-card text-center">
        <div class="error-code mb-5">
          <span>4</span>
          <span>0</span>
          <span>4</span>
        </div>

        <h1 class="error-title mb-3">
          Oops! {{ $t('errors.404') }}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error-1",
  mounted() {},
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/error/bg1.jpg";
    }
  }
};
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  background: radial-gradient(circle at top left, #dbeafe 0, #f9fafb 36%, #f3f4f6 100%);
  display: flex; 
  align-items: center; 
  justify-content: center;
}

.error-code {
  font-size: clamp(6rem, 16vw, 10rem);
  font-weight: 800;
  letter-spacing: 0.14em;
  color: #0C5280;
  text-shadow: 0 16px 40px rgba(30, 64, 175, 0.35);
}

.error-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #111827;
}

.error-text {
  font-size: 0.98rem;
  color: #6b7280;
}
.error-image {
  max-height: 260px;
  object-fit: contain;
  filter: drop-shadow(0 18px 45px rgba(15, 23, 42, 0.18));
}

@media (max-width: 576px) {
  .error-card {
    padding: 2rem 1.5rem;
  }
}
</style>
